const stocks = [
  {
    ticker: "AAPL",
    web: "https://www.apple.com/",
    ratio: 20,
    price: 181.2,
    actual_price: 192.2,
    target: 150,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Altos",
    Ratios: ["P/Sales", "EV/EBITDA", "EV/FCF"],
    Targets: [6, 20, 18],
    image: "/images/AAPL2.png",
    category: "Tecnologico",
    name: "Apple Inc",
    Acciones: 15576,
    Revenue: 385706,
    COGS: 212035,
    OpIncome: 118658,
    NetIncome: 100913,
    Debt: 95088,
    CashandEquiv: 73100,
    DandA: 11460,
    CAPEX: 10559,
    Acciones2018:19821,
    Acciones2019:17770,
    Acciones2020:17000,
    Acciones2021:16410,
    Acciones2022:15910,
    Acciones2023:15550,
    Revenue2023: 383285,
    Revenue2022: 394328,
    Revenue2021: 365817,
    Revenue2020: 274515,
    Revenue2019: 260170,
    Revenue2018: 265359,
    NetIncome2023: 96995,
    NetIncome2022: 99803,
    NetIncome2021: 94680,
    NetIncome2020: 57411,
    NetIncome2019: 55260,
    NetIncome2018: 59531,
    description:
      "Apple diseña, fabrica y comercializa teléfonos inteligentes, tabletas, ordenadores personales y dispositivos para llevar puestos. La empresa ofrece aplicaciones de software y servicios relacionados, accesorios y contenidos digitales de terceros. La cartera de productos de incluye iPhone, iPad, Mac, iPod, Apple Watch y Apple TV. También ofrece servicios de publicidad, servicios de pago, servicios en la nube, entre otros.",
  },
  {
    ticker: "ABT",
    web: "https://www.abbott.com/",
    ratio: 4,
    price: 119,
    actual_price:"",
    target: 80,
    riesgo: "Bajo",
    deuda: "Media",
    crecimiento: "Bajo",
    margenes: "Medios",
    image: "/images/ABT.png",
    category: "Farmaceutico",
    name: "Abbott Laboratories",
    Acciones:1748,
    Revenue:40109,
    COGS:17975,
    OpIncome:6478,
    NetIncome:5723,
    Debt:14477,
    CashandEquiv:7047,
    DandA:3236,
    CAPEX:1827,
    Acciones2018:1758,
    Acciones2019:1763,
    Acciones2020:1771,
    Acciones2021:1763,
    Acciones2022:1737,
    Acciones2023:1735,
    Revenue2023: 40109,
    Revenue2022: 43653,
    Revenue2021: 43075,
    Revenue2020: 34608,
    Revenue2019: 31900,
    Revenue2018: 30578,
    NetIncome2023: 5723,
    NetIncome2022: 6933,
    NetIncome2021: 7071,
    NetIncome2020: 4495,
    NetIncome2019: 3687,
    NetIncome2018: 2368,
    description:
      "Abbott desarrolla, fabrica y vende una gama diversificada de productos sanitarios que incluye productos farmacéuticos genéricos de marca, sistemas y pruebas de diagnóstico y productos nutricionales pediátricos y para adultos. La empresa también ofrece diversos dispositivos médicos, como dispositivos para la insuficiencia cardiaca, electrofisiología, gestión del ritmo, dispositivos vasculares y estructurales del corazón y dispositivos de neuromodulación.",
  },
  {
    ticker: "ADBE",
    web: "https://www.adobe.com/",
    ratio: 44,
    price: 550,
    actual_price:"",
    target: 350,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Altos",
    image: "/images/ADBE.png",
    category: "Tecnologico",
    name: "Adobe",
    Acciones:460,
    Revenue:19409,
    COGS:2354,
    OpIncome:6650,
    NetIncome:5428,
    Debt:3634,
    CashandEquiv:7842,
    DandA:872,
    CAPEX:360,
    Acciones2018:491,
    Acciones2019:482,
    Acciones2020:479,
    Acciones2021:472,
    Acciones2022:458,
    Acciones2023:452,
    Revenue2023: 19409,
    Revenue2022: 17606,
    Revenue2021: 15785,
    Revenue2020: 12868,
    Revenue2019: 11170,
    Revenue2018: 9030,
    NetIncome2023: 5428,
    NetIncome2022: 4756,
    NetIncome2021: 4822,
    NetIncome2020: 5260,
    NetIncome2019: 2951,
    NetIncome2018: 2591,
    description:
      "Adobe ofrece productos de software de marketing digital, multimedia y creatividad. Sus productos y servicios son utilizados por profesionales creativos, trabajadores del conocimiento, estudiantes, vendedores, desarrolladores de aplicaciones, consumidores y empresas para crear, gestionar, entregar, medir, optimizar, interactuar y realizar transacciones con contenidos y experiencias atractivas que abarcan dispositivos, ordenadores personales y medios de comunicación.",
  },
  {
    ticker: "AMD",
    web: "https://www.amd.com/",
    price: 138.6, actual_price:"",
    ratio:10,
    target:100,
    riesgo: "Alto",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Bajos",
    image: "/images/AMD.png",
    category: "Tecnologico",
    name: "AMD",
    Acciones:1628,
    Revenue:22680,
    COGS:11278,
    OpIncome:401,
    NetIncome:854,
    Debt:1717,
    CashandEquiv:5773,
    DandA:3453,
    CAPEX:546,
    Acciones2018: 982,
    Acciones2019:1170,
    Acciones2020:1211,
    Acciones2021:1199,
    Acciones2022:1611,
    Acciones2023:1616,
    Revenue2023: 22680,
    Revenue2022: 23601,
    Revenue2021: 16434,
    Revenue2020: 9763,
    Revenue2019: 6731,
    Revenue2018: 6475,
    NetIncome2023: 854,
    NetIncome2022: 1320,
    NetIncome2021: 3162,
    NetIncome2020: 2490,
    NetIncome2019: 341,
    NetIncome2018: 337,
    description:
      "Es una empresa especializada en la fabricación de dispositivos semiconductores. Sus principales productos son microprocesadores, chipsets para placas base, procesadores integrados, procesadores gráficos y FPGA para servidores, estaciones de trabajo, ordenadores personales y aplicaciones de sistemas integrados, centros de datos y la informática de alto rendimiento (utilizada para la IA).",
},
  {
    ticker: "AMZN",
    web: "https://www.aboutamazon.com/",
    ratio: 144,
    price: 145.2,
    actual_price: "",
    target: 160,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Alto",
    margenes: "Bajos",
    Ratios: ["P/Sales", "EV/EBITDA", "EV/FCF"],
    Targets: [2.5, 20, 18],
    image: "/images/AMZN.png",
    category: "Tecnologico",
    name: "Amazon Inc.",
    Acciones: 10610,
    Revenue: 574785,
    COGS: 304739,
    OpIncome: 36852,
    NetIncome: 30425,
    Debt: 58314,
    CashandEquiv: 86780,
    DandA: 48663,
    CAPEX: 52729,
    Acciones2018: 9740,
    Acciones2019:9956,
    Acciones2020:10070,
    Acciones2021:10180,
    Acciones2022:10250,
    Acciones2023:10390,
    Revenue2023: 574785,
    Revenue2022: 513983,
    Revenue2021: 469822,
    Revenue2020: 386064,
    Revenue2019: 280520,
    Revenue2018: 232887,
    NetIncome2023: 30425,
    NetIncome2022: -2722,
    NetIncome2021: 33364,
    NetIncome2020: 21331,
    NetIncome2019: 11590,
    NetIncome2018: 10073,
    description:
      "Es la mayor empresa de comercio electrónico del mundo y vendiendo productos de terceros y propios. También ofrece servicios de computación en la nube (el segmento que más crece y más beneficios produce en la actualidad), así como productos de software, música, videojuegos, electrónica, libros, ropa, muebles y hasta comida.Cuenta con ventas anuales de 520 billones de dólares, con unos ingresos netos de 25 billones de dólares.",
  },
  {
    ticker: "AXP",
    web: "https://www.americanexpress.com/es-ar/",
    ratio: 15,
    price: 190,
    actual_price: "",
    target: 160,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Medios",
    image: "/images/AXP.png",
    category: "Financiero",
    name: "American Express",
    Acciones: 726,
    Revenue: 55592,
    COGS: 45079,
    OpIncome: 10513,
    NetIncome: 8345,
    Debt: 46447,
    CashandEquiv: 43908,
    DandA: 1658,
    CAPEX: 1538,
    Acciones2018:856,
    Acciones2019:808,
    Acciones2020:806,
    Acciones2021:759,
    Acciones2022:744,
    Acciones2023:724,
    Revenue2023: 60363,
    Revenue2022: 52560,
    Revenue2021: 43147,
    Revenue2020: 36239,
    Revenue2019: 39980,
    Revenue2018: 37271,
    NetIncome2023: 8374,
    NetIncome2022: 7514,
    NetIncome2021: 8060,
    NetIncome2020: 3135,
    NetIncome2019: 6759,
    NetIncome2018: 6921,
    description:
      "American Express es una empresa de pagos integrada a nivel mundial que ofrece a sus clientes acceso a productos, conocimientos y experiencias que enriquecen sus vidas y contribuyen al éxito de sus negocios.",
  },
  {
    ticker: "AZN", 
    web: "https://www.astrazeneca.com/",
    ratio: 2,
    price: 66,
    actual_price: "",
    target: 55,
    riesgo: "Bajo",
    deuda: "Media",
    crecimiento: "Bajo",
    margenes: "Medios",
    image: "/images/AZN.png",
    category: "Farmaceutico",
    name: "AstraZeneca",
    Acciones:3120,
    Revenue:45811,
    COGS:8268,
    OpIncome:8193,
    NetIncome:5961,
    Debt:22365,
    CashandEquiv:5840,
    DandA:5387,
    CAPEX:1361,
    Acciones2018: 2534,
    Acciones2019:2624,
    Acciones2020:2626,
    Acciones2021:3098,
    Acciones2022:3100,
    Acciones2023:3120,
    Revenue2023: 45811,
    Revenue2022: 44351,
    Revenue2021: 37417,
    Revenue2020: 26617,
    Revenue2019: 24380,
    Revenue2018: 22123,
    NetIncome2023: 5955,
    NetIncome2022: 3288,
    NetIncome2021: 112,
    NetIncome2020: 3196,
    NetIncome2019: 1335,
    NetIncome2018: 2155,
    description:
      "AstraZeneca es una empresa biofarmacéutica centrada en el descubrimiento, la producción y la comercialización de una serie de medicamentos de venta con receta. Desarrolla productos relacionados con áreas terapéuticas como las enfermedades respiratorias, cardiovasculares, renales y metabólicas, el cáncer, las enfermedades autoinmunes, infecciosas y neurológicas. La cartera de productos de la empresa incluye productos biológicos, fármacos de prescripción y vacunas.",
  },
  {
    ticker: "BA",
    web: "https://www.boeing.com/",
    ratio: 24,
    price: 200,
    actual_price: "",
    target: 120,
    riesgo: "Alto",
    deuda: "Alta",
    crecimiento: "Medio",
    margenes: "Bajos",
    image: "/images/BA.png",
    category: "Industrial",
    name: "Boeing",
    Acciones:610,
    Revenue:77794,
    COGS:70070,
    OpIncome:-773,
    NetIncome:-2231,
    Debt:47103,
    CashandEquiv:15965,
    DandA:1861,
    CAPEX:1527,
    Acciones2018:579,
    Acciones2019:563,
    Acciones2020:583,
    Acciones2021:583,
    Acciones2022:598,
    Acciones2023:610,
    Revenue2023: 77794,
    Revenue2022: 66608,
    Revenue2021: 62286,
    Revenue2020: 58158,
    Revenue2019: 76560,
    Revenue2018: 101127,
    NetIncome2023: -2222,
    NetIncome2022: -4935,
    NetIncome2021: -4202,
    NetIncome2020: -11941,
    NetIncome2019: -636,
    NetIncome2018: 10460,
    description:
      "Boeing es una empresa aeroespacial. La empresa diseña, desarrolla y fabrica principalmente aviones comerciales y militares. También desarrolla sistemas espaciales, de defensa y de seguridad. La empresa ofrece varios modelos de aviones y reactores de negocios para fines comerciales, de formación y militares. Su cartera incluye varios modelos de fuselaje estrecho y ancho, aeronaves de rotor y rotor basculante, aviones cisterna, aviones antisubmarinos y otros aviones y helicópteros de ataque.",
  },
  {
    ticker: "BABA",
    web: "https://www.alibabagroup.com/en-US/",
    ratio: 9,
    price: 73,
    actual_price: "",
    target: 120,
    riesgo: "Alto",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Medios",
    Ratios: ["P/Sales", "PER", "P/EBITDA"],
    Targets: [1, 6, 5],
    image: "/images/BABA2.png",
    category: "Tecnologico",
    name: "Alibaba",
    Acciones: 2540,
    Revenue: 136242,
    COGS: 82656,
    OpIncome: 16769,
    NetIncome: 12569,
    Debt: 19658,
    CashandEquiv: 78202,
    DandA: 10988,
    CAPEX: 5266,
    Acciones2018:2580,
    Acciones2019:2603,
    Acciones2020:2704,
    Acciones2021:2718,
    Acciones2022:2648,
    Acciones2023:2540,
    Revenue2023: 868687,
    Revenue2022: 853062,
    Revenue2021: 717289,
    Revenue2020: 509711,
    Revenue2019: 376840,
    Revenue2018: 250294,
    NetIncome2023: 72783,
    NetIncome2022: 62249,
    NetIncome2021: 150578,
    NetIncome2020: 149433,
    NetIncome2019: 87890,
    NetIncome2018: 63992,
    description:
      "Es un holding proveedor de comercio electrónico y servicios de infraestructura. Proporciona servicios de infraestructura tecnológica a comerciantes, marcas, minoristas y empresas para comercializar, vender y operar a través de Internet. Sus negocios abarcan el comercio, medios digitales y el entretenimiento, la computación en nube entre otras. Presta servicios a través de sus filiales, Freshippo, Aliexpress, Alibaba.com, Alibaba Cloud, etc.",
  },
  {
    ticker: "BAC",
    web: "https://www.bankofamerica.com/",
    ratio: 4,
    price: 34.4,
    actual_price: "",
    target: 30,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/BAC.png",
    category: "Financiero",
    name: "Bank of America",
    Acciones: 8062,
    Revenue: 98581,
    COGS: 65845,
    OpIncome: 28342,
    NetIncome: 25704,
    Debt: 2892836,
    CashandEquiv: 3179900,
    DandA: 2047,
    CAPEX: 0,
    Acciones2018:9096,
    Acciones2019:8728,
    Acciones2020:8633,
    Acciones2021:8070,
    Acciones2022:8004,
    Acciones2023:7872,
    Revenue2023: 98581,
    Revenue2022: 94950,
    Revenue2021: 89113,
    Revenue2020: 85528,
    Revenue2019: 85580,
    Revenue2018: 84650,
    NetIncome2023: 25704,
    NetIncome2022: 27528,
    NetIncome2021: 31978,
    NetIncome2020: 17894,
    NetIncome2019: 27430,
    NetIncome2018: 28147,
    description:
      "Es una de las principales instituciones financieras del mundo, ofrece a particulares, pequeñas y grandes empresas una amplia gama de productos y servicios de banca, inversión, gestión de activos y otros productos y servicios financieros y de gestión de riesgos. Cuenta con unos activos de $3.120 billones, representados por más de 48 millones de clientes. Durante el año 2022 tuvo ventas de $95 billiones y ganancias por $27 billones.",
  },
  // {
  //   ticker: "BBD",
  //   price: 12.5, actual_price:"",
  //   web: "https://banco.bradesco/html/classic/",
  //   ratio: 1,
  //   target: 16, //Hay que ver como hacer que tome el precio en Reales
  //   riesgo: "Medio",
  //   deuda: "Baja",
  //   crecimiento: "Bajo",
  //   margenes: "Medios",
  //   image: "/images/BBD.png",
  //   category: "Financiero",
  //   name: "Banco Bradesco",
  //   Acciones:10642,
  //   Revenue:100274,
  //   COGS:0,
  //   OpIncome:14502,
  //   NetIncome:14502,
  //   Debt:1760509,
  //   CashandEquiv:1927523,
  //   DandA:0,
  //   CAPEX:0,
  //   Revenue2023: 100274,
  //   Revenue2022: 109001,
  //   Revenue2021: 102428,
  //   Revenue2020: 82368,
  //   Revenue2019: 82368,
  // Revenue2018:,//   
  // NetIncome2023: 14503,
  //   NetIncome2022: 20983,
  //   NetIncome2021: 23172,
  //   NetIncome2020: 15836,
  //   NetIncome2019: 15836,
  // NetIncome2018:,//   
  // description:
  //     "Banco Bradesco es un proveedor de banca comercial y soluciones financieras relacionadas para grandes, medianas y pequeñas empresas, particulares, grandes corporaciones locales e internacionales e instituciones. Ofrece servicios de banca personal y corporativa, banca internacional, banca privada y de inversión, gestión de activos, mercado de capitales y seguros.",
  // },
  {
    ticker: "BIIB",
    web: "https://www.biogen.com/",
    ratio: 13,
    price: 220,
    actual_price: "",
    target: 175,
    riesgo: "Alto",
    deuda: "Media",
    crecimiento: "Bajo",
    margenes: "Medios",
    image: "/images/BIIB5.png",
    category: "Farmaceutico",
    name: "Biogen Inc",
    Acciones: 146,
    Revenue: 9835,
    COGS: 2534,
    OpIncome: 1296,
    NetIncome: 1162,
    Debt: 6788,
    CashandEquiv: 1049,
    DandA: 479,
    CAPEX: 286,
    Acciones2018:190,
    Acciones2019:174,
    Acciones2020:152,
    Acciones2021:147,
    Acciones2022:144,
    Acciones2023:145,
    Revenue2023: 9835,
    Revenue2022: 10173,
    Revenue2021: 10981,
    Revenue2020: 13444,
    Revenue2019: 14380,
    Revenue2018: 13453,
    NetIncome2023: 1161,
    NetIncome2022: 3046,
    NetIncome2021: 1556,
    NetIncome2020: 4000,
    NetIncome2019: 5888,
    NetIncome2018: 4431,
    description:
      "Biogen Inc. desarrolla, fabrica y suministra terapias para el tratamiento de enfermedades neurológicas y neurodegenerativas. La empresa suministra medicamentos para la esclerosis múltiple, la atrofia muscular espinal, la enfermedad el Alzheimer, la psoriasis en placas entre otras enfermedades.",
  },
  {
    ticker: "BRK-B",
    web:"https://www.berkshirehathaway.com/",
    ratio: 22,
    price: 365.59, 
    actual_price:"",
    target:300,
    riesgo: "Bajo",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/BRKB.png",
    category: "Financiero",
    name: "Berkshire Hathaway",
    Acciones:2175,
    Revenue:364482,
    COGS:228955,
    OpIncome:120000,
    NetIncome:96223,
    Debt:125000,
    CashandEquiv:168000,
    DandA:9357,
    CAPEX:13701,
    Acciones2018:2465,
    Acciones2019:2450,
    Acciones2020:2391,
    Acciones2021:2265,
    Acciones2022:2203,
    Acciones2023:2173,
    Revenue2023: 364482,
    Revenue2022: 234190,
    Revenue2021: 354745,
    Revenue2020: 286325,
    Revenue2019: 254620,
    Revenue2018: 247837,
    NetIncome2023: 96223,
    NetIncome2022: -22819,
    NetIncome2021: 89795,
    NetIncome2020: 42521,
    NetIncome2019: 81420,
    NetIncome2018: 4021,
    description:
      "Es la matriz de un holding empresarial que produce y comercializa productos de todo tipo como materiales de construcción, seguros, productos de consumo o productos financieros, entre otros muchos. Al mismo tiempo la empresa invierte en otras cotizantes de la bolsa. Actualmente las principales posiciones de la empresa son: 	Apple Inc (51%), Bank of America (8.51%), American Express (7.59%), Coca Cola Company (6.92%) y Chevron (5.56%).",
  },
  // {
  //   ticker: "BSBR",
  //   price: 13.4, actual_price:"",
  //   web: "https://www.santander.com.br/",
  //   ratio: 1,
  //   target: 15, //Hay que ver como hacer que tome el precio en Reales
  //   riesgo: "Medio",
  //   deuda: "Baja",
  //   crecimiento: "Bajo",
  //   margenes: "Medios",
  //   image: "/images/BSBR.png",
  //   category: "Financiero",
  //   name: "Banco Santander",
  //   Acciones:7444,
  //   Revenue:65864,
  //   COGS:0,
  //   OpIncome:11921,
  //   NetIncome:9498,
  //   Debt:1000796,
  //   CashandEquiv:1115652,
  //   DandA:0,
  //   CAPEX:0,
  //   Revenue2023: 65864,
  //   Revenue2022: 43173,
  //   Revenue2021: 48674,
  //   Revenue2020: 32552,
  //   Revenue2019: 32552,
  // Revenue2018:,//   
  // NetIncome2023: 9499,
  //   NetIncome2022: 14287,
  //   NetIncome2021: 15528,
  //   NetIncome2020: 13418,
  //   NetIncome2019: 13418,
  // NetIncome2018:,//   
  // description:
  //     "Banco Santander ofrece servicios de banca comercial y mayorista. La categoría de banca personal incluye tarjetas; cuentas; préstamos para necesidades personales, nómina y préstamos para automóviles; seguros de vida y no vida; y gestión de inversiones. La banca de empresas comprende préstamos para capital circulante; gestión de tesorería; soluciones de pago y recepción; seguros inmobiliarios; y gestión de riesgos financieros.",
  // },
  {
    ticker: "CVX",
    web: "https://www.chevron.com/",
    ratio: 16,
    price: 152.7,
    target: 120,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Medios",
    image: "/images/CVX.png",
    category: "Commodity",
    name: "Chevron Corp",
    Acciones: 1868,
    Revenue: 200949,
    COGS: 119196,
    OpIncome: 29583,
    NetIncome: 21353,
    Debt: 19201,
    CashandEquiv: 8178,
    DandA: 17372,
    CAPEX: 15868,
    Acciones2018:1897,
    Acciones2019:1879,
    Acciones2020:1926,
    Acciones2021:1947,
    Acciones2022:1907,
    Acciones2023:1857,
    Revenue2023: 200949,
    Revenue2022: 235717,
    Revenue2021: 155606,
    Revenue2020: 94471,
    Revenue2019: 139865,
    Revenue2018: 158902,
    NetIncome2023: 21353,
    NetIncome2022: 35465,
    NetIncome2021: 15625,
    NetIncome2020: -5543,
    NetIncome2019: 2924,
    NetIncome2018: 14824,
    description:
      "Es una empresa integrada de petróleo y gas. La empresa explora, produce y transporta petróleo crudo y gas natural; refina, comercializa y distribuye combustibles y lubricantes para el transporte; y vende productos petroquímicos y aditivos. Chevron tiene intereses en instalaciones de conversión de gas en líquido en sus regiones operativas. Actualmente es la segunda empresa que mas petroleo produce en EEUU.",
  },
  {
    ticker: "DE",
    web: "https://www.deere.com/en/",
    ratio: 40,
    price: 365,
    target: 400,
    riesgo: "Medio",
    deuda: "Alta",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/DE.png",
    category: "Industrial",
    name: "Deere & Co",
    Acciones: 281,
    Revenue: 60785,
    COGS: 36981,
    OpIncome: 12742,
    NetIncome: 9958,
    Debt: 39933,
    CashandEquiv: 6273,
    DandA: 2130,
    CAPEX: 1568,
    Acciones2018:323,
    Acciones2019:313,
    Acciones2020:313,
    Acciones2021:307,
    Acciones2022:298,
    Acciones2023:280,
    Revenue2023: 60248,
    Revenue2022: 51282,
    Revenue2021: 43033,
    Revenue2020: 34722,
    Revenue2019: 39230,
    Revenue2018: 36578,
    NetIncome2023: 10166,
    NetIncome2022: 7131,
    NetIncome2021: 5963,
    NetIncome2020: 2751,
    NetIncome2019: 3253,
    NetIncome2018: 2368,
    description:
      "Deere & Company se dedica a la fabricación y distribución de diversos equipos para la agricultura. La empresa opera a través de cuatro segmentos: Producción y Agricultura de Precisión, Pequeña Agricultura y Césped, Construcción y Silvicultura, y Servicios Financieros. Ofrece tractores grandes y medianos, cosechadoras, equipos de césped y utilitarios, así como implementos para siega, labranza, manipulación de nieve y escombros, aireación y aplicaciones residenciales, comerciales, entre otros.",
  },
  {
    ticker: "DIS",
    web: "https://thewaltdisneycompany.com/",
    ratio: 12,
    price: 90.9,
    actual_price: "",
    target: 120,
    riesgo: "Medio",
    deuda: "Alta",
    crecimiento: "Bajo",
    margenes: "Bajos",
    image: "/images/DIS2.png",
    category: "Consumo",
    name: "Walt Disney Co",
    Acciones: 1835,
    Revenue: 88935,
    COGS: 79000,
    OpIncome: 5535,
    NetIncome: 3203,
    Debt: 41603,
    CashandEquiv: 7192,
    DandA: 5304,
    CAPEX: 5053,
    Acciones2018:1650,
    Acciones2019:1802,
    Acciones2020:1810,
    Acciones2021:1818,
    Acciones2022:1824,
    Acciones2023:1830,
    Revenue2023: 88898,
    Revenue2022: 82722,
    Revenue2021: 67418,
    Revenue2020: 65388,
    Revenue2019: 69610,
    Revenue2018: 59434,
    NetIncome2023: 2354,
    NetIncome2022: 3145,
    NetIncome2021: 1995,
    NetIncome2020: -2864,
    NetIncome2019: 11050,
    NetIncome2018: 12598,
    description:
      "Es una empresa de entretenimiento y medios de comunicación. Produce y adquiere programas de televisión, películas de acción y películas de animación. La empresa posee y explota parques temáticos y complejos turísticos, así como redes y canales de televisión; desarrolla y publica libros, cómics y revistas; vende productos relacionados con los temas de Disney. Tambien explota canales de cable (Disney, ESPN, FX, Freeform, etc.).",
  },
  {
    ticker: "GE",
    web: "https://www.ge.com/",
    ratio: 8,
    price: 120.7,
    target: 90,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Alto",
    margenes: "Medios",
    image: "/images/GE.png",
    category: "Industrial",
    name: "General Electric",
    Acciones: 1099,
    Revenue: 67954,
    COGS: 50392,
    OpIncome: 9029,
    NetIncome: 9443,
    Debt: 19711,
    CashandEquiv: 22673,
    DandA: 2079,
    CAPEX: 1595,
    Acciones2018:1086,
    Acciones2019:1092,
    Acciones2020:1096,
    Acciones2021:1099,
    Acciones2022:1089,
    Acciones2023:1088,
    Revenue2023: 67954,
    Revenue2022: 58099,
    Revenue2021: 56469,
    Revenue2020: 75834,
    Revenue2019: 90220,
    Revenue2018: 116615,
    NetIncome2023: 9481,
    NetIncome2022: 339,
    NetIncome2021: -6337,
    NetIncome2020: 5704,
    NetIncome2019: -4979,
    NetIncome2018: -22355,
    description:
      "Es un conglomerado industrial que frece una gama de productos y servicios industriales, de infraestructuras y financieros. La empresa ofrece desde motores y sistemas aeronáuticos, sistemas sanitarios y diagnósticos farmacéuticos, generación de energía y equipos de producción de petróleo y gas hasta imágenes médicas, financiación y productos industriales. También ofrece una amplia gama de servicios financieros a sus clientes.",
  },
  {
    ticker: "GLOB",
    web: "https://www.globant.com/",
    ratio: 18,
    price: 226,
    target: 100,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Bajos",
    image: "/images/GLOB.png",
    category: "Tecnologico",
    name: "Globant",
    Acciones:44,
    Revenue:2095,
    COGS:1340,
    OpIncome:198,
    NetIncome:167,
    Debt:54,
    CashandEquiv:323,
    DandA:112,
    CAPEX:118,
    Acciones2018:36,
    Acciones2019:37,
    Acciones2020:40,
    Acciones2021:42,
    Acciones2022:42,
    Acciones2023:43,
    Revenue2023: 2095,
    Revenue2022: 1780,
    Revenue2021: 1297,
    Revenue2020: 814,
    Revenue2019: 659,
    Revenue2018: 522,
    NetIncome2023: 167,
    NetIncome2022: 148,
    NetIncome2021: 96,
    NetIncome2020: 54,
    NetIncome2019: 54,
    NetIncome2018: 52,
    description:
      "Globant ofrece servicios de desarrollo de productos de software. La empresa ofrece servicios como adecuación organizativa, proceso de IA, automatización, estrategia, push it live y build and evolve. También proporciona hacking empresarial, aceleración de productos, marketing digital, inteligencia artificial, ciencias de la vida, juegos y ciberseguridad. El estudio de informatización empresarial de Globant diseña y construye soluciones empresariales que permiten el desarrollo de modelos de negocio competitivos.",
  },
  {
    ticker: "GOLD",
    web: "https://www.barrick.com/English/home/default.aspx",
    ratio: 2,
    price: 14.6,
    actual_price: "",
    target: 20,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/GOLD.png",
    category: "Commodity",
    name: "Barrick Gold",
    Acciones: 1756,
    Revenue: 11397,
    COGS: 7932,
    OpIncome: 2984,
    NetIncome: 1953,
    Debt: 4715,
    CashandEquiv: 4148,
    DandA: 2043,
    CAPEX: 3086,
    Acciones2018:1167,
    Acciones2019:1778,
    Acciones2020:1778,
    Acciones2021:1779,
    Acciones2022:1755,
    Acciones2023:1756,
    Revenue2023: 11397,
    Revenue2022: 11013,
    Revenue2021: 11985,
    Revenue2020: 12595,
    Revenue2019: 9717,
    Revenue2018: 7243,
    NetIncome2023: 1953,
    NetIncome2022: 432,
    NetIncome2021: 2022,
    NetIncome2020: 2324,
    NetIncome2019: 3969,
    NetIncome2018: -1545,
    description:
      "Es una empresa minera dedicada a la extracción de oro y otros minerales. Se dedica principalmente a la producción y venta de oro y cobre, además de actividades relacionadas como exploración y desarrollo de minas. La empresa cuenta con 13 minas de oro y 3 de cobre distribuidas por 15 países. Para el año 2023 planea producir 4,4 millones de onzas ($8.580.000.000) de oro y 450 millones de libras de cobre ($1.700.000.000).",
  },
  {
    ticker: "GOOG",
    web: "https://abc.xyz/",
    ratio: 58,
    price: 137.4,
    actual_price: "",
    target: 150,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Altos",
    image: "/images/GOOG.png",
    category: "Tecnologico",
    name: "Alphabet Inc.",
    Acciones: 12630,
    Revenue: 307394,
    COGS: 133332,
    OpIncome: 84293,
    NetIncome: 73795,
    Debt: 13253,
    CashandEquiv: 110916,
    DandA: 13326,
    CAPEX: 32251,
    Acciones2018:13902,
    Acciones2019:13750,
    Acciones2020:13480,
    Acciones2021:13220,
    Acciones2022:12810,
    Acciones2023:12430,
    Revenue2023: 307394,
    Revenue2022: 282836,
    Revenue2021: 257637,
    Revenue2020: 182527,
    Revenue2019: 161860,
    Revenue2018: 136819,
    NetIncome2023: 73795,
    NetIncome2022: 59972,
    NetIncome2021: 76033,
    NetIncome2020: 40269,
    NetIncome2019: 34340,
    NetIncome2018: 30736,
    description:
      "Alphabet ofrece una enorme cantidad de productos y servicios, pero en líneas generales, divide sus ventas en 3 distintos segmentos: Google Services, Google Cloud y Other Bets. Google Cloud es el segmento más prometedor de Alphabet, y consiste en un conjunto de recursos físicos, como computadoras y unidades de disco duro, y recursos virtuales que se encuentran en los centros de datos de Google en todo el mundo.",
  },
  {
    ticker: "HAL",
    web: "https://www.halliburton.com/",
    ratio: 2,
    price: 35,
    actual_price: "",
    target: 35,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Altos",
    image: "/images/HAL.png",
    category: "Commodity",
    name: "Halliburton",
    Acciones: 897,
    Revenue: 23018,
    COGS: 13501,
    OpIncome: 4083,
    NetIncome: 2662,
    Debt: 7636,
    CashandEquiv: 2264,
    DandA: 998,
    CAPEX: 1379,
    Acciones2018:875,
    Acciones2019:880,
    Acciones2020:888,
    Acciones2021:899,
    Acciones2022:905,
    Acciones2023:890,
    Revenue2023: 23018,
    Revenue2022: 20297,
    Revenue2021: 15295,
    Revenue2020: 14445,
    Revenue2019: 22410,
    Revenue2018: 23995,
    NetIncome2023: 2638,
    NetIncome2022: 1572,
    NetIncome2021: 1457,
    NetIncome2020: -2945,
    NetIncome2019: -1131,
    NetIncome2018: 1656,
    description:
      "Halliburton Company ofrece productos y servicios a la industria petrolera. Ofrece servicios en toda la cadena petrolera desde el Downstream hasta el Upstream. Con mas de 100 años operando es una empresa con muy buena reputacion y un historial de crecimiento intachable.",
  },
  {
    ticker: "HPQ",
    web: "https://www.hp.com/",
    ratio: 1,
    price: 30,
    actual_price: "",
    target: 28,
    riesgo: "Bajo",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Bajos",
    image: "/images/HPQ.png",
    category: "Industrial",
    name: "HP Inc",
    Acciones: 1000,
    Revenue: 53718,
    COGS: 42210,
    OpIncome: 3456,
    NetIncome: 2937,
    Debt: 9254,
    CashandEquiv: 3232,
    DandA: 850,
    CAPEX: 609,
    Acciones2018:1515,
    Acciones2019:1453,
    Acciones2020:1290,
    Acciones2021:1083,
    Acciones2022:982,
    Acciones2023:990,
    Revenue2023: 53718,
    Revenue2022: 62910,
    Revenue2021: 63460,
    Revenue2020: 56638,
    Revenue2019: 58760,
    Revenue2018: 58472,
    NetIncome2023: 3263,
    NetIncome2022: 3132,
    NetIncome2021: 6541,
    NetIncome2020: 2815,
    NetIncome2019: 3152,
    NetIncome2018: 5327,
    description:
      "Es un fabricante de productos tecnológicos, software, soluciones y servicios. La cartera de productos de la empresa incluye informática personal y otros dispositivos de acceso; impresoras; infraestructura informática empresarial; y servicios al cliente de múltiples proveedores.  HP ofrece sus productos a consumidores individuales y grandes empresas, incluidos clientes de los sectores gubernamental, sanitario y educativo.",
  },
  {
    ticker: "INTC",
    web: "https://www.intel.la/content/www/xl/es/homepage.html",
    ratio: 5,
    price: 46.89,
    actual_price: "",
    target: 30,
    riesgo: "Alto",
    deuda: "Media",
    crecimiento: "Bajo",
    margenes: "Bajos",
    image: "/images/INTC.png",
    category: "Tecnologico",
    name: "Intel",
    Acciones: 4212,
    Revenue: 54228,
    COGS: 32517,
    OpIncome: 93,
    NetIncome: 1689,
    Debt: 46978,
    CashandEquiv: 25034,
    DandA: 7847,
    CAPEX: 25750,
    Acciones2018:4411,
    Acciones2019:4277,
    Acciones2020:4063,
    Acciones2021:4072,
    Acciones2022:4137,
    Acciones2023:4228,
    Revenue2023: 54228,
    Revenue2022: 63054,
    Revenue2021: 79024,
    Revenue2020: 77867,
    Revenue2019: 71970,
    Revenue2018: 70848,
    NetIncome2023: 1689,
    NetIncome2022: 8014,
    NetIncome2021: 19868,
    NetIncome2020: 20899,
    NetIncome2019: 21050,
    NetIncome2018: 21053,
    description:
      "Es uno de los mayores fabricantes de circuitos integrados del mundo y la creadora de la serie de procesadores x86, los procesadores más comúnmente encontrados en la mayoría de las computadoras personales. Actualmente Intel está pasando por un duro momento con una gran caída de ventas del 20% entre 2021 y 2022 y una caída de las ganancias del 60% en el mismo periodo.",
  },
  {
    ticker: "JNJ",
    web: "https://www.jnj.com/",
    ratio: 15,
    price: 158,
    target: 120,
    riesgo: "Bajo",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/JNJ2.png",
    category: "Farmaceutico",
    name: "Johnson & Johnson",
    Acciones: 2430,
    Revenue: 93022,
    COGS: 30011,
    OpIncome: 23508,
    NetIncome: 19343,
    Debt: 26051,
    CashandEquiv: 23511,
    DandA: 7472,
    CAPEX: 3921,
    Acciones2018:2681,
    Acciones2019:2634,
    Acciones2020:2638,
    Acciones2021:2629,
    Acciones2022:2604,
    Acciones2023:2408,
    Revenue2023: 93022,
    Revenue2022: 94943,
    Revenue2021: 93775,
    Revenue2020: 82584,
    Revenue2019: 82060,
    Revenue2018: 81581,
    NetIncome2023: 19343,
    NetIncome2022: 17941,
    NetIncome2021: 20878,
    NetIncome2020: 14714,
    NetIncome2019: 15120,
    NetIncome2018: 15297,
    description:
      "Es una empresa multinacional estadounidense, fabrica dispositivos médicos, productos farmacéuticos, de cuidado personal, perfumes y artículos para bebés. La corporación está conformada por 230 subsidiarias que operan en más de 57 países cuyos productos se venden en más de 175 países. Las principales marcas son Band-Aid, Clean & Clear, Listerine, Neutrogena, Sinutab y Splenda.",
  },
  {
    ticker: "JPM",
    web: "https://www.jpmorganchase.com/",
    ratio: 15,
    price: 172.27,
    actual_price: "",
    target: 200,
    riesgo: "Bajo",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/JPM.png",
    category: "Financiero",
    name: "JP Morgan",
    Acciones: 2914,
    Revenue: 158104,
    COGS: 87172,
    OpIncome: 61602,
    NetIncome: 49552,
    Debt: 3547515,
    CashandEquiv: 3875393,
    DandA: 0,
    CAPEX: 0,
    Acciones2018:3240,
    Acciones2019:3074,
    Acciones2020:3051,
    Acciones2021:2953,
    Acciones2022:2943,
    Acciones2023:2880,
    Revenue2023: 158104,
    Revenue2022: 128641,
    Revenue2021: 121685,
    Revenue2020: 119883,
    Revenue2019: 110130,
    Revenue2018: 105482,
    NetIncome2023: 49552,
    NetIncome2022: 37676,
    NetIncome2021: 48334,
    NetIncome2020: 29131,
    NetIncome2019: 36430,
    NetIncome2018: 32474,
    description:
      "Es el mayor banco de EEUU y una de las mayores empresas financieras del mundo, con activos financieros de más de 3,87 trillones de dólares ($3.870.000.000.000). Es uno de los bancos más antiguos del mundo, con su origen en 1799. La empresa es líder en inversiones bancarias, servicios financieros, gestión de activos financieros e inversiones privadas. La unidad de fondos de inversión (hedge funds) del banco es la más grande de los Estados Unidos.      ",
  },
  {
    ticker: "KO",
    web: "https://www.coca-colacompany.com/",
    ratio: 5,
    target: 50,
    price: 59.67,
    actual_price: "",
    riesgo: "Bajo",
    deuda: "Media",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/KO.png",
    category: "Consumo",
    name: "Coca Cola Co",
    Acciones: 4330,
    Revenue: 45754,
    COGS: 18520,
    OpIncome: 11311,
    NetIncome: 10727,
    Debt: 35547,
    CashandEquiv: 12363,
    DandA: 1128,
    CAPEX: 1852,
    Acciones2018:4259,
    Acciones2019:4290,
    Acciones2020:4309,
    Acciones2021:4335,
    Acciones2022:4327,
    Acciones2023:4312,
    Revenue2023: 45754,
    Revenue2022: 43004,
    Revenue2021: 38655,
    Revenue2020: 33014,
    Revenue2019: 37270,
    Revenue2018: 31856,
    NetIncome2023: 10727,
    NetIncome2022: 9542,
    NetIncome2021: 9771,
    NetIncome2020: 7747,
    NetIncome2019: 8920,
    NetIncome2018: 6434,
    description:
      "Es una corporación multinacional estadounidense de bebidas que fabrica, vende a minorista y comercializa concentrados y jarabes para bebidas no alcohólicas. Cuenta con ventas anuales cercanas a 50 billones de dólares y con ingresos netos cercanos a 10 billones. Como se puede observar el margen de la empresa es muy interesante, de cada 100 dólares que ingresa, 20 se convierten en beneficios.",
  },
  {
    ticker: "LMT",
    web: "https://www.lockheedmartin.com/",
    ratio: 20,
    price: 421.7,
    actual_price: "",
    target: 335,
    riesgo: "Bajo",
    deuda: "Media",
    crecimiento: "Bajo",
    margenes: "Medios",
    name: "Lockheed Martin",
    category: "Tecnologico",
    image: "/images/LMT.png",
    Acciones: 251,
    Revenue: 67571,
    COGS: 59092,
    OpIncome: 8507,
    NetIncome: 6920,
    Debt: 17291,
    CashandEquiv: 1442,
    DandA: 1404,
    CAPEX: 1670,
    Acciones2018:284,
    Acciones2019:282,
    Acciones2020:280,
    Acciones2021:272,
    Acciones2022:255,
    Acciones2023:242,
    Revenue2023: 67571,
    Revenue2022: 65984,
    Revenue2021: 67044,
    Revenue2020: 65398,
    Revenue2019: 59810,
    Revenue2018: 53762,
    NetIncome2023: 6920,
    NetIncome2022: 5732,
    NetIncome2021: 6315,
    NetIncome2020: 6833,
    NetIncome2019: 6230,
    NetIncome2018: 5046,
    description:
      "Es una empresa aeroespacial y de seguridad, se dedica a la investigación, diseño, desarrollo, fabricación, integración y mantenimiento de sistemas, productos y servicios tecnológicos en todo el mundo. La empresa opera a través de los segmentos Aeronáutica, Misiles y Control de Incendios, Sistemas Rotativos y de Misión, y Espacio.",
  },
  {
    ticker: "MCD",
    web: "https://www.mcdonalds.com/us/en-us.html",
    ratio: 24,
    price: 367.7,
    target: 190,
    riesgo: "Medio",
    deuda: "Alta",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/MCD.png",
    category: "Consumo",
    name: "Mc Donald",
    Acciones: 728,
    Revenue: 25492,
    COGS: 8223,
    OpIncome: 11921,
    NetIncome: 8468,
    Debt: 37153,
    CashandEquiv: 4579,
    DandA: 1978,
    CAPEX: 2169,
    Acciones2018:768,
    Acciones2019:745,
    Acciones2020:746,
    Acciones2021:743,
    Acciones2022:731,
    Acciones2023:722,
    Revenue2023: 25492,
    Revenue2022: 23182,
    Revenue2021: 23222,
    Revenue2020: 19207,
    Revenue2019: 21360,
    Revenue2018: 21025,
    NetIncome2023: 8468,
    NetIncome2022: 6177,
    NetIncome2021: 7545,
    NetIncome2020: 4730,
    NetIncome2019: 6025,
    NetIncome2018: 5924,
    description:
      "Es un operador de cadenas minoristas de restaurantes de comida rapida. La empresa explota y franquicia restaurantes McDonald's que sirven un menú local de comida y bebida. También ofrece varios productos para el desayuno. McDonald's comercializa sus productos bajo una amplia gama de marcas, como Big Mac, Filet-O-Fish, McFlurry, Chicken McNuggets, McMuffin y McGriddles. Opera en America, Europa, Asia, Oceanía y África.",
  },
  {
    ticker: "MELI",
    price: 1629.8, actual_price:"",
    web: "https://investor.mercadolibre.com/",
    ratio: 120,
    target:1200,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Alto",
    margenes: "Medios",
    image: "/images/MELI.png",
    category: "Tecnologico",
    name: "Mercado Libre",
    Acciones:51,
    Revenue:14473,
    COGS:7267,
    OpIncome:1823,
    NetIncome:987,
    Debt:2203,
    CashandEquiv:7328,
    DandA:1011,
    CAPEX:509,
    Acciones2018:45,
    Acciones2019:50,
    Acciones2020:50,
    Acciones2021:50,
    Acciones2022:50,
    Acciones2023:51,
    Revenue2023: 14473,
    Revenue2022: 10537,
    Revenue2021: 7069,
    Revenue2020: 3974,
    Revenue2019: 2296,
    Revenue2018: 1439,
    NetIncome2023: 987,
    NetIncome2022: 482,
    NetIncome2021: 83,
    NetIncome2020: -1,
    NetIncome2019: -172,
    NetIncome2018: -36,
    description:
      "Mercado Libre Inc es un operador de una plataforma de comercio en línea. La cartera de servicios de la empresa incluye servicios de pago digitales y móviles, servicios de publicidad y servicios de solución de tiendas en línea. También proporciona servicios a sus usuarios para transacciones comerciales tanto offline como online.",

},
  {
    ticker: "META",
    web: "https://www.meta.com/",
    ratio: 24,
    price: 490,
    actual_price: "",
    target: 270,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Alto",
    margenes: "Altos",
    image: "/images/META.png",
    category: "Tecnologico",
    name: "Meta Platforms",
    Acciones: 2629,
    Revenue: 134902,
    COGS: 25959,
    OpIncome: 46751,
    NetIncome: 39098,
    Debt: 18385,
    CashandEquiv: 65403,
    DandA: 11178,
    CAPEX: 27266,
    Acciones2018:2890,
    Acciones2019:2850,
    Acciones2020:2847,
    Acciones2021:2722,
    Acciones2022:2593,
    Acciones2023:2550,
    Revenue2023: 134902,
    Revenue2022: 116609,
    Revenue2021: 117929,
    Revenue2020: 85965,
    Revenue2019: 70700,
    Revenue2018: 55838,
    NetIncome2023: 39098,
    NetIncome2022: 23200,
    NetIncome2021: 39370,
    NetIncome2020: 29146,
    NetIncome2019: 18490,
    NetIncome2018: 22112,
    description:
      "Es un conglomerado estadounidense de tecnología y redes sociales. Es la empresa matriz de Facebook, Instagram, WhatsApp y otras subsidiarias. Últimamente está realizando fuertes inversiones en el metaverso a través de Oculus (empresa que produce dispositivos de realidad virtual). La principal vía de ingresos de la empresa es a través de la venta de anuncios a sus comercializadores.",
  },
  {
    ticker: "MMM",
    web: "https://www.3m.com/",
    ratio: 10,
    price: 108.6,
    actual_price: "",
    target: 80,
    riesgo: "Alto",
    deuda: "Alta",
    crecimiento: "Bajo",
    margenes: "Medios",
    image: "/images/MMM.png",
    category: "Industrial",
    name: "3M Co",
    Acciones: 555,
    Revenue: 32681,
    COGS: 18477,
    OpIncome: 5615,
    NetIncome: 4695,
    Debt: 30088,
    CashandEquiv: 5933,
    DandA: 1450,
    CAPEX: 1257,
    Acciones2018:588,
    Acciones2019:576,
    Acciones2020:579,
    Acciones2021:571,
    Acciones2022:550,
    Acciones2023:553,
    Revenue2023: 32681,
    Revenue2022: 34229,
    Revenue2021: 35355,
    Revenue2020: 32184,
    Revenue2019: 32140,
    Revenue2018: 32765,
    NetIncome2023: -6995,
    NetIncome2022: 5777,
    NetIncome2021: 5921,
    NetIncome2020: 5449,
    NetIncome2019: 4517,
    NetIncome2018: 5349,
    description:
      "Es un fabricante y distribuidor de productos y soluciones industriales. La cartera de productos de la empresa incluye materiales avanzados, materiales y sistemas de visualización, cuidado del hogar, mejora del hogar, papelería y oficina, seguridad personal, gránulos para tejados, sistemas de cierre y enmascaramiento y otros. 3M también ofrece soluciones como sistemas médicos, de salud, de seguridad alimentaria y de información sanitaria.",
  },
  {
    ticker: "MSFT",
    web: "https://www.microsoft.com",
    ratio: 30,
    price: 367.7,
    actual_price: "",
    target: 300,
    riesgo: "Bajo",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Altos",
    name: "Microsoft",
    category: "Tecnologico",
    image: "/images/MSFT1.png",
    Acciones: 7468,
    Revenue: 227583,
    COGS: 68848,
    OpIncome: 100533,
    NetIncome: 82541,
    Debt: 41990,
    CashandEquiv: 111262,
    DandA: 17303,
    CAPEX: 35202,
    Acciones2018:7700,
    Acciones2019:7635,
    Acciones2020:7568,
    Acciones2021:7515,
    Acciones2022:7458,
    Acciones2023:7430,
    Revenue2023: 211915,
    Revenue2022: 198270,
    Revenue2021: 168088,
    Revenue2020: 143015,
    Revenue2019: 125840,
    Revenue2018: 110360,
    NetIncome2023: 72361,
    NetIncome2022: 72738,
    NetIncome2021: 61271,
    NetIncome2020: 44281,
    NetIncome2019: 39240,
    NetIncome2018: 16571,
    description:
      "Microsoft produce software, productos electrónicos, computadoras personales y servicios relacionados. La empresa desarrolla, fabrica, licencia y da soporte a ordenadores personales, servidores y dispositivos electrónicos. Sus productos más conocidos son el sistema operativo Microsoft Windows y el paquete Microsoft Office. El segmento Azure es uno de los más prometedores de la empresa, es una plataforma de computación en la nube.",
  },
  {
    ticker: "NFLX",
    web: "https://ir.netflix.net/ir-overview/profile/default.aspx",
    ratio: 48,
    price: 474.06,
    actual_price: "",
    target: 400,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Altos",
    image: "/images/NFLX.png",
    category: "Tecnologico",
    name: "Netflix",
    Acciones: 449,
    Revenue: 33723,
    COGS: 19715,
    OpIncome: 6954,
    NetIncome: 5407,
    Debt: 14143,
    CashandEquiv: 7137,
    DandA: 14197,
    CAPEX: 12554,
    Acciones2018:437,
    Acciones2019:439,
    Acciones2020:443,
    Acciones2021:444,
    Acciones2022:445,
    Acciones2023:433,
    Revenue2023: 33723,
    Revenue2022: 31615,
    Revenue2021: 29697,
    Revenue2020: 24996,
    Revenue2019: 20160,
    Revenue2018: 15794,
    NetIncome2023: 5407,
    NetIncome2022: 4491,
    NetIncome2021: 5116,
    NetIncome2020: 2761,
    NetIncome2019: 1866,
    NetIncome2018: 1211,
    description:
      "Netflix  es un proveedor de servicios de entretenimiento. La empresa ofrece programas de televisión y películas, como series originales, documentales y largometrajes, a través de una suscripción por Internet en televisión, ordenador y dispositivos móviles. También ofrece una amplia gama de actividades de ocio, videojuegos y otras fuentes de entretenimiento. Netflix licencia, adquiere y produce contenidos, incluida programación original.",
  },
  {
    ticker: "NKE",
    web: "https://www.nike.com/",
    ratio: 12,
    price: 100.06,
    target: 80,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Medios",
    image: "/images/NKE.png",
    category: "Consumo",
    name: "Nike",
    Acciones: 1532,
    Revenue: 51656,
    COGS: 28874,
    OpIncome: 6695,
    NetIncome: 5718,
    Debt: 8999,
    CashandEquiv: 9927,
    DandA: 764,
    CAPEX: 964,
    Acciones2018:1623,
    Acciones2019:1567,
    Acciones2020:1560,
    Acciones2021:1582,
    Acciones2022:1568,
    Acciones2023:1530,
    Revenue2023: 51217,
    Revenue2022: 46710,
    Revenue2021: 44538,
    Revenue2020: 37403,
    Revenue2019: 39120,
    Revenue2018: 36397,
    NetIncome2023: 5070,
    NetIncome2022: 6046,
    NetIncome2021: 5727,
    NetIncome2020: 2539,
    NetIncome2019: 4029,
    NetIncome2018: 1933,
    description:
      "NIKE diseña, comercializa y distribuye calzado, ropa, equipamiento y accesorios deportivos para hombres, mujeres y niños. Comercializa y distribuye productos de fútbol, béisbol, tenis y actividades al aire libre. También vende mochilas, calcetines, balones deportivos, gafas, relojes, dispositivos digitales, bates, guantes, equipos de protección, entre otros. La empresa comercializa estos productos bajo diversas marcas, como Nike, Jordan y Converse.",
  },
  {
    ticker: "NVDA",
    web: "https://www.nvidia.com/es-la/",
    ratio: 24,
    price: 788,
    target: 500, 
    actual_price:"",
    image: "/images/NVDA.png",
    category: "Tecnologico",
    riesgo: "Alto",
    deuda: "Baja",
    crecimiento: "Alto",
    margenes: "Altos",
    name: "Nvidia",
    description:
      "Se dedica a fabricar procesadores gráficos, tecnologías móviles y computadoras y desarrolla de circuitos integrados, que se utilizan en todo tipo de dispositivos, desde consolas de juegos electrónicos hasta ordenadores personales (PC). La compañía es uno de los principales fabricantes de unidades de procesamiento gráfico (GPU) de alta gama, utilizadas para el almacenamiento en la nube e inteligencia artificial.",
    Acciones:2490,
    Revenue:60922,
    COGS:16621,
    OpIncome:32972,
    NetIncome:29759,
    Debt:8459,
    CashandEquiv:25984,
    DandA:1508,
    CAPEX:1068,
    Acciones2018:2432,
    Acciones2019:2448,
    Acciones2020:2480,
    Acciones2021:2506,
    Acciones2022:2470,
    Acciones2023:2500,
    Revenue2023: 60922,  
    Revenue2022: 26974,  
    Revenue2021: 26914,  
    Revenue2020: 16675,  
    Revenue2019: 10920,
    Revenue2018: 11716,
    NetIncome2023: 29760,
    NetIncome2022: 4368, 
    NetIncome2021: 9752, 
    NetIncome2020: 4332, 
    NetIncome2019: 2796,
    NetIncome2018: 4141,
  },
  {
    ticker: "PEP",
    web: "https://www.pepsico.com/",
    ratio: 18,
    price: 169,
    actual_price: "",
    target: 120,
    riesgo: "Medio",
    deuda: "Media",
    crecimiento: "Alto",
    margenes: "Medios",
    image: "/images/PEP.png",
    category: "Consumo",
    name: "Pepsi Co",
    Acciones: 1381,
    Revenue: 91471,
    COGS: 41881,
    OpIncome: 11986,
    NetIncome: 9074,
    Debt: 37595,
    CashandEquiv: 10003,
    DandA: 2948,
    CAPEX: 5518,
    Acciones2018:1410,
    Acciones2019:1390,
    Acciones2020:1380,
    Acciones2021:1383,
    Acciones2022:1377,
    Acciones2023:1374,
    Revenue2023: 91471,
    Revenue2022: 86392,
    Revenue2021: 79474,
    Revenue2020: 70372,
    Revenue2019: 67160,
    Revenue2018: 64661,
    NetIncome2023: 9074,
    NetIncome2022: 8910,
    NetIncome2021: 7618,
    NetIncome2020: 7120,
    NetIncome2019: 7314,
    NetIncome2018: 12515,
    description:
      "Es una empresa dedicada a la fabricación, comercialización y distribución de bebidas y aperitivos. Sobre la base de los ingresos netos, PepsiCo es la segunda mayor empresa de alimentos y bebidas en el mundo, presente en más de 200 países con diferentes marcas (algunas regionales). En América del Norte, PepsiCo es la mayor empresa de alimentos y bebidas. Las principales marcas son: Pepsi, Seven Up, Lays, Gatorade, Cheetos, etc.",
  },
  {
    ticker: "PFE",
    web: "https://www.pfizer.com/",
    ratio: 4,
    price: 29.47,
    actual_price: "",
    target: 20,
    riesgo: "Alto",
    deuda: "Alta",
    crecimiento: "Bajo",
    margenes: "Bajos",
    image: "/images/PFE.png",
    category: "Farmaceutico",
    name: "Pfizer Inc",
    Acciones: 5647,
    Revenue: 58497,
    COGS: 24954,
    OpIncome: 2022,
    NetIncome: 2119,
    Debt: 61048,
    CashandEquiv: 3000,
    DandA: 10243,
    CAPEX: 4002,
    Acciones2018:5872,
    Acciones2019:5548,
    Acciones2020:5578,
    Acciones2021:5623,
    Acciones2022:5619,
    Acciones2023:5647,
    Revenue2023: 58497,
    Revenue2022: 100330,
    Revenue2021: 81288,
    Revenue2020: 41651,
    Revenue2019: 40910,
    Revenue2018: 42158,
    NetIncome2023: 2119,
    NetIncome2022: 31372,
    NetIncome2021: 21979,
    NetIncome2020: 9159,
    NetIncome2019: 16030,
    NetIncome2018: 11153,
    description:
      "Pfizer diseña, desarrolla, fabrica y comercializa productos biofarmacéuticos. La empresa ofrece productos para tratar diversas afecciones, como las cardiovasculares, metabólicas y del dolor, la salud de la mujer, el cáncer, la inflamación, los trastornos inmunitarios y las enfermedades raras. También suministra productos farmacéuticos inyectables estériles, biosimilares, ingredientes farmacéuticos activos (API) y servicios de fabricación por contrato.",
  },
  {
    ticker: "PG",
    web: "https://www.pginvestor.com/corporate-profile/default.aspx",
    ratio: 15,
    price: 157.06,
    target: 120,
    riesgo: "Bajo",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/PG.png",
    category: "Consumo",
    name: "Procter & Gamble",
    Acciones: 2468,
    Revenue: 83933,
    COGS: 41662,
    OpIncome: 18610,
    NetIncome: 14795,
    Debt: 23096,
    CashandEquiv: 7890,
    DandA: 2798,
    CAPEX: 3252,
    Acciones2018:2529,
    Acciones2019:2502,
    Acciones2020:2486,
    Acciones2021:2427,
    Acciones2022:2389,
    Acciones2023:2357,
    Revenue2023: 82006,
    Revenue2022: 80187,
    Revenue2021: 76118,
    Revenue2020: 70950,
    Revenue2019: 67680,
    Revenue2018: 66832,
    NetIncome2023: 14653,
    NetIncome2022: 14742,
    NetIncome2021: 14306,
    NetIncome2020: 13027,
    NetIncome2019: 3897,
    NetIncome2018: 9750,
    description:
      "Es un fabricante y comercializador de bienes de consumo, su cartera de productos comprende acondicionadores, champú, cuchillas y maquinas de afeitar masculinas y femeninas, cepillos de dientes, pasta dentífrica, líquidos lavavajillas, detergentes, etc. También ofrece toallitas para bebés, pañales, toallas y pañuelos de papel y papel higiénico. Sus marcas son Head & Shoulders, Tide, Ariel, Olay, Pantene, Pampers, Gillette, Braun y Fusion.",
  },
  {
    ticker: "PYPL",
    web: "https://www.paypal.com/",
    ratio: 8,
    price: 60.12,
    actual_price: "",
    target: 80,
    riesgo: "Alto",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Altos",
    image: "/images/PYPL2.png",
    category: "Financiero",
    name: "Paypal",
    Acciones: 1084,
    Revenue: 29771,
    COGS: 17521,
    OpIncome: 5101,
    NetIncome: 4246,
    Debt: 11300,
    CashandEquiv: 17300,
    DandA: 1072,
    CAPEX: 626,
    Acciones2018:1183,
    Acciones2019:1173,
    Acciones2020:1171,
    Acciones2021:1165,
    Acciones2022:1131,
    Acciones2023:1072,
    Revenue2023: 29771,
    Revenue2022: 27518,
    Revenue2021: 25371,
    Revenue2020: 21454,
    Revenue2019: 17770,
    Revenue2018: 15451,
    NetIncome2023: 4246,
    NetIncome2022: 2419,
    NetIncome2021: 4169,
    NetIncome2020: 4202,
    NetIncome2019: 2459,
    NetIncome2018: 2057,
    description:
      "PayPal es una plataforma de pago con un sitio web y una aplicación que permite realizar pagos entre partes mediante transferencias de dinero por Internet. Además de pagos en línea, PayPal ofrece una tarjeta de débito para pagos, lectores de tarjetas de crédito para su uso en empresas y líneas de crédito. PayPal se considera uno de los métodos mas seguros de pago en Internet, su reputación lo respalda.",
  },
  {
    ticker: "SBUX",
    web: "https://www.starbucks.com/",
    ratio: 12,
    price: 93,
    actual_price: "",
    target: 60,
    riesgo: "Medio",
    deuda: "Media",
    crecimiento: "Medio",
    margenes: "Medios",
    image: "/images/SBUX.png",
    category: "Consumo",
    name: "Starbucks",
    Acciones: 1140,
    Revenue: 36687,
    COGS: 26486,
    OpIncome: 6102,
    NetIncome: 4293,
    Debt: 13564,
    CashandEquiv: 3383,
    DandA: 1479,
    CAPEX: 2432,
    Acciones2018:1292,
    Acciones2019:1181,
    Acciones2020:1173,
    Acciones2021:1173,
    Acciones2022:1148,
    Acciones2023:1137,
    Revenue2023: 35975,
    Revenue2022: 32250,
    Revenue2021: 29060,
    Revenue2020: 23518,
    Revenue2019: 26510,
    Revenue2018: 24719,
    NetIncome2023: 4124,
    NetIncome2022: 3281,
    NetIncome2021: 4199,
    NetIncome2020: 928,
    NetIncome2019: 3599,
    NetIncome2018: 4518,
    description:
      "Starbucks opera como tostador, comercializador y minorista de café. Sus tiendas ofrecen bebidas de café y té, café tostado en grano y molido, productos en porciones individuales y bebidas listas para beber, así como diversos productos de alimentación, como bollería, sándwiches para el desayuno y almuerzos. También concede licencias de sus marcas a través de tiendas autorizadas.",
  },
  {
    ticker: "T",
    web: "https://www.att.com/",
    ratio: 3,
    price: 17,
    target: 14,
    riesgo: "Alto",
    deuda: "Alta",
    crecimiento: "Medio",
    margenes: "Medios",
    image: "/images/T.png",
    category: "Consumo",
    name: "AT&T",
    Acciones: 7150,
    Revenue: 122428,
    COGS: 23136,
    OpIncome: 23461,
    NetIncome: 14549,
    Debt: 127854,
    CashandEquiv: 6722,
    DandA: 18777,
    CAPEX: 17853,
    Acciones2018:6778,
    Acciones2019:7173,
    Acciones2020:7132,
    Acciones2021:7143,
    Acciones2022:7130,
    Acciones2023:7153,
    Revenue2023: 122428,
    Revenue2022: 120741,
    Revenue2021: 134038,
    Revenue2020: 171760,
    Revenue2019: 181190,
    Revenue2018: 170805,
    NetIncome2023: 14549,
    NetIncome2022: -8524,
    NetIncome2021: 20081,
    NetIncome2020: -5176,
    NetIncome2019: 13900,
    NetIncome2018: 19370,
    description:
      "Es un proveedor de servicios de telecomunicaciones, medios de comunicación y tecnología. La empresa ofrece comunicaciones inalámbricas, servicios de datos/banda ancha e Internet, servicios telefónicos locales y de larga distancia, equipos de telecomunicaciones, redes gestionadas y servicios mayoristas. AT&T también desarrolla, produce y distribuye largometrajes, televisión, juegos y otros contenidos.",
  },
  {
    ticker:"TS",
    web: "https://www.tenaris.com/en",
    ratio: 1,
    price: 36,
    target: 30,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Altos",
    image:"/images/TEN.png",
    category:"Industrial",
    name:"Tenaris",
    Acciones:1180,
    Revenue:14868,
    COGS:8667,
    OpIncome:4316,
    NetIncome:3956,
    Debt:535,
    CashandEquiv:3922,
    DandA:548,
    CAPEX:619,
    Acciones2018:1181,
    Acciones2019:1181,
    Acciones2020:1181,
    Acciones2021:1181,
    Acciones2022:1181,
    Acciones2023:1168,
    Revenue2023: 14868,
    Revenue2022: 11762,
    Revenue2021: 6521,
    Revenue2020: 5146,
    Revenue2019: 7290,
    Revenue2018: 7658,
    NetIncome2023: 3956,
    NetIncome2022: 2553,
    NetIncome2021: 1100,
    NetIncome2020: -634,
    NetIncome2019: 743,
    NetIncome2018: 876,
    description:"Es un fabricante de productos tubulares de acero. Produce y vende productos tubulares de acero sin soldadura y soldados y servicios relacionados. La cartera de productos incluye casing, tubing, line pipe, varillas de bombeo, coiled tubing, grados de acero y tubos mecánicos y estructurales. Tenaris presta servicios a empresas de Oil&Gas dedicadas a la construcción de instalaciones de extracción, transporte, procesamiento de petróleo y gas.",
  },
  {
    ticker: "TSLA",
    web: "https://www.tesla.com/",
    ratio: 15,
    price: 197,
    actual_price: "",
    target: 150,
    riesgo: "Alto",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Medios",
    image: "/images/TSLA.png",
    category: "Tecnologico",
    name: "Tesla Motors",
    Acciones: 3181,
    Revenue: 96773,
    COGS: 79113,
    OpIncome: 8891,
    NetIncome: 8930,
    Debt: 11010,
    CashandEquiv: 29094,
    DandA: 4667,
    CAPEX: 8898,
    Acciones2018:2587,
    Acciones2019:2720,
    Acciones2020:2880,
    Acciones2021:3100,
    Acciones2022:3164,
    Acciones2023:3185,
    Revenue2023: 96773,
    Revenue2022: 81462,
    Revenue2021: 53823,
    Revenue2020: 31536,
    Revenue2019: 24580,
    Revenue2018: 21461,
    NetIncome2023: 14999,
    NetIncome2022: 12583,
    NetIncome2021: 5524,
    NetIncome2020: 721,
    NetIncome2019: -860,
    NetIncome2018: -976,
    description:
      "Tesla diseña, fabrica y vende automóviles eléctricos, componentes, techos solares, instalaciones solares fotovoltaicas y baterías domésticas. Posee centros de datos gigantescos y su sistema de conducción autónomo (alimentado con IA) es un desarrollo de muchos años que en un futuro la empresa va a poder vender a sus competidores. También desarrolló los cargadores eléctricos más eficientes del mercado.",
  },
  {
    ticker: "UBER",
    web: "https://www.uber.com/",
    ratio: 2,
    price: 78,
    actual_price: "",
    target: 40,
    riesgo: "Alto",
    deuda: "Media",
    crecimiento: "Bajo",
    margenes: "Bajos",
    image: "/images/UBER.png",
    category: "Tecnologico",
    name: "Uber Technologies",
    Acciones:2121,
    Revenue:37281,
    COGS:22457,
    OpIncome:1110,
    NetIncome:1108,
    Debt:9459,
    CashandEquiv:6212,
    DandA:823,
    CAPEX:223,
    Acciones2018:1682,
    Acciones2019:1724,
    Acciones2020:1858,
    Acciones2021:1954,
    Acciones2022:2010,
    Acciones2023:2076,
    Revenue2023: 37281,
    Revenue2022: 31877,
    Revenue2021: 17455,
    Revenue2020: 11139,
    Revenue2019: 13000,
    Revenue2018: 11270,
    NetIncome2023: 1887,
    NetIncome2022: -9141,
    NetIncome2021: -496,
    NetIncome2020: -6768,
    NetIncome2019: -8506,
    NetIncome2018: -3022,
    description:
      "Uber es un proveedor de servicios de transporte por carretera. Ofrece servicios a través de sus plataformas tecnológicas, como aplicaciones móviles y sitios web. Uber pone en contacto a usuarios con conductores o proveedores independientes de soluciones de transporte. La empresa ofrece servicios de recogida y entrega en aeropuertos de todos los continentes. La empresa, a través de su plataforma tecnológica, ofrece servicios de entrega de alimentos, comidas y comestibles.",
  },
  {
    ticker: "UNH",
    web: "https://www.unitedhealthgroup.com/",
    ratio: 33,
    price: 527,
    actual_price: "",
    target: 450,
    riesgo: "Bajo",
    deuda: "Media",
    crecimiento: "Bajo",
    margenes: "Bajos",
    image: "/images/UNH.png",
    category: "Farmaceutico",
    name: "UnitedHealth Group",
    Acciones:935,
    Revenue:371652,
    COGS:339264,
    OpIncome:29112,
    NetIncome:22544,
    Debt:58263,
    CashandEquiv:29628,
    DandA:3972,
    CAPEX:3386,
    Acciones2018:961,
    Acciones2019:949,
    Acciones2020:945,
    Acciones2021:941,
    Acciones2022:933,
    Acciones2023:935,
    Revenue2023: 371652,
    Revenue2022: 324162,
    Revenue2021: 287597,
    Revenue2020: 257141,
    Revenue2019: 242160,
    Revenue2018: 226247,
    NetIncome2023: 22544,
    NetIncome2022: 20120,
    NetIncome2021: 17285,
    NetIncome2020: 15403,
    NetIncome2019: 13840,
    NetIncome2018: 11986,
    description:
      "UnitedHealth Group es una empresa diversificada de atención sanitaria. Ofrece servicios y productos sanitarios a través de dos plataformas distintas: UnitedHealthcare y Optum. Su plataforma UnitedHealthcare proporciona cobertura sanitaria y servicios de prestaciones, y la plataforma Optum ofrece servicios sanitarios basados en la información y la tecnología.",
  },
  {
    ticker: "V",
    web: "https://www.visa.com/",
    ratio: 18,
    price: 280.06,
    target: 200,
    riesgo: "Bajo",
    deuda: "Baja",
    crecimiento: "Alto",
    margenes: "Altos",
    image: "/images/V3.png",
    category: "Financiero",
    name: "Visa",
    Acciones: 2299,
    Revenue: 33376,
    COGS: 11108,
    OpIncome: 22268,
    NetIncome: 18193,
    Debt: 20703,
    CashandEquiv: 20212,
    DandA: 1416,
    CAPEX: 1452,
    Acciones2018:2244,
    Acciones2019:2147,
    Acciones2020:2125,
    Acciones2021:2100,
    Acciones2022:2057,
    Acciones2023:2008,
    Revenue2023: 32653,
    Revenue2022: 29310,
    Revenue2021: 24105,
    Revenue2020: 21846,
    Revenue2019: 22980,
    Revenue2018: 20880,
    NetIncome2023: 17273,
    NetIncome2022: 14957,
    NetIncome2021: 12311,
    NetIncome2020: 10866,
    NetIncome2019: 12080,
    NetIncome2018: 10301,
    description:
      "Es una multinacional de servicios financieros que facilita las transferencias electrónicas de fondos en todo el mundo, a través de tarjetas de crédito, débito, prepago, regalo y monedero con la marca Visa. Visa no emite tarjetas, no otorga crédito ni establece tasas y tarifas para los consumidores; proporciona a las instituciones financieras productos de pago con la marca Visa que luego usan para ofrecer servicios a sus clientes.",
  },
  {
    ticker: "VIST",
    price: 36, actual_price:"",
    web: "https://www.vistaenergy.com/",
    ratio: 3,
    target: 25,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/VIST.png",
    category: "Commodity",
    name: "Vista Energy",
    Acciones:98,
    Revenue:1133,
    COGS:543,
    OpIncome:631,
    NetIncome:397,
    Debt:555,
    CashandEquiv:213,
    DandA:276,
    CAPEX:691,
    Acciones2018:86,
    Acciones2019:87,
    Acciones2020:88,
    Acciones2021:89,
    Acciones2022:93,
    Acciones2023:95,
    Revenue2023: 1133,
    Revenue2022: 1143,
    Revenue2021: 652,
    Revenue2020: 273,
    Revenue2019: 416,
    Revenue2018: 376,
    NetIncome2023: 397,
    NetIncome2022: 269,
    NetIncome2021: 50,
    NetIncome2020: -102,
    NetIncome2019: -32,
    NetIncome2018: -33,
    description:
      "Vista es un operador independiente líder, con sus principales activos en Vaca Muerta, el mayor yacimiento de shale oil y shale gas en desarrollo fuera de Norteamérica. Vista planea desarrollar su inventario de perforación de petróleo de esquisto de alto rendimiento de hasta 1,150 pozos que abarcan 205,600 acres de Vaca Muerta, con un enfoque en la eficiencia de costos y la producción de menor intensidad de carbono.",
},
  {
    ticker: "VZ",
    web: "https://www.verizon.com/",
    ratio: 4,
    price: 40.06,
    target: 30,
    riesgo: "Alto",
    deuda: "Alta",
    crecimiento: "Medio",
    margenes: "Altos",
    image: "/images/VZ.png",
    category: "Consumo",
    name: "Verizon",
    Acciones: 4214,
    Revenue: 133974,
    COGS: 54887,
    OpIncome: 28718,
    NetIncome: 17936,
    Debt: 137701,
    CashandEquiv: 2065,
    DandA: 17624,
    CAPEX: 18767,
    Acciones2018:4126,
    Acciones2019:4136,
    Acciones2020:4138,
    Acciones2021:4198,
    Acciones2022:4200,
    Acciones2023:4204,
    Revenue2023: 133974,
    Revenue2022: 136835,
    Revenue2021: 133613,
    Revenue2020: 128292,
    Revenue2019: 131870,
    Revenue2018: 130863,
    NetIncome2023: 11614,
    NetIncome2022: 21256,
    NetIncome2021: 22065,
    NetIncome2020: 17801,
    NetIncome2019: 19270,
    NetIncome2018: 15528,
    description:
      "Proporciona productos y servicios de comunicaciones, tecnología, información y entretenimiento a personas y empresas. Ofrece servicios y soluciones de voz, datos y vídeo a través de sus redes inalámbricas y fijas, servicios y productos de comunicaciones inalámbricas y por cable, como soluciones de redes corporativas, servicios de centros de datos y en la nube, servicios de seguridad y redes gestionadas, etc.",
  },
  {
    ticker: "WFC",
    web: "https://www.wellsfargo.com/",
    ratio: 5,
    price: 52.06,
    target: 40,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Altos",
    image: "/images/WFC.png",
    category: "Financiero",
    name: "Wells Fargo",
    Acciones: 3657,
    Revenue: 82617,
    COGS: 55562,
    OpIncome: 20001,
    NetIncome: 19142,
    Debt: 1745025,
    CashandEquiv: 1932468,
    DandA: 0,
    CAPEX: 0,
    Acciones2018:4389,
    Acciones2019:4100,
    Acciones2020:4134,
    Acciones2021:3814,
    Acciones2022:3794,
    Acciones2023:3577,
    Revenue2023: 82617,
    Revenue2022: 73785,
    Revenue2021: 78492,
    Revenue2020: 74264,
    Revenue2019: 84230,
    Revenue2018: 82540,
    NetIncome2023: 19142,
    NetIncome2022: 13182,
    NetIncome2021: 21548,
    NetIncome2020: 3377,
    NetIncome2019: 19720,
    NetIncome2018: 22393,
    description:
      "Es una institucion financiera que ofrece servicios bancarios minoristas y mayoristas, servicios de gestión de patrimonios a particulares, empresas, e instituciones. Ofrece una gama de préstamos comerciales y al consumo, financiación agrícola, productos de tarjetas, servicios de depósito y servicios de transacciones. Presta servicios de banca hipotecaria, agencia y seguros, corretaje de valores y banca de inversión, entre otros.",
  },
  {
    ticker: "WMT",
    web: "https://stock.walmart.com/home/",
    price: 156.71,
    actual_price:"",
    ratio: 54,
    target: 42,
    riesgo: "Bajo",
    deuda: "Baja",
    crecimiento: "Medio",
    margenes: "Bajos",
    image: "/images/WMT.png",
    category: "Consumo",
    name: "Walmart",
    Acciones:2701,
    Revenue:648125,
    COGS:490142,
    OpIncome:27012,
    NetIncome:14653,
    Debt:36132,
    CashandEquiv:9867,
    DandA:11853,
    CAPEX:20606,
    Acciones2018:8787,
    Acciones2019:8497,
    Acciones2020:8451,
    Acciones2021:8255,
    Acciones2022:8087,
    Acciones2023:8070,
    Revenue2023: 648130,
    Revenue2022: 611289,
    Revenue2021: 572754,
    Revenue2020: 559151,
    Revenue2019: 523960,
    Revenue2018: 511729,
    NetIncome2023: 15510,
    NetIncome2022: 11680,
    NetIncome2021: 13673,
    NetIncome2020: 13510,
    NetIncome2019: 14880,
    NetIncome2018: 6670,
    description:
      "Walmart opera cadenas de grandes supermercados y tiendas minoristas en todo el mundo (principalmente en Estados Unidos). Walmart tiene casi 11.000 tiendas bajo 65 marcas en 28 países y cuenta con sitios web de comercio electrónico en 11 países. Cuenta con más de dos millones de empleados y en el año 2022 obtuvo ventas por 611 billones de dólares convirtiéndose en la empresa con mayores ventas del mundo.",
  },
  {
    ticker: "XOM",
    web: "https://corporate.exxonmobil.com/",
    ratio: 10,
    price: 102.63,
    actual_price: "",
    target: 80,
    riesgo: "Medio",
    deuda: "Baja",
    crecimiento: "Bajo",
    margenes: "Medios",
    image: "/images/XOM2.png",
    category: "Commodity",
    name: "Exxon Mobil",
    Acciones: 4010,
    Revenue: 344582,
    COGS: 229914,
    OpIncome: 52783,
    NetIncome: 36010,
    Debt: 37483,
    CashandEquiv: 31539,
    DandA: 20641,
    CAPEX: 21919,
    Acciones2018:4232,
    Acciones2019:4232,
    Acciones2020:4233,
    Acciones2021:4234,
    Acciones2022:4071,
    Acciones2023:3971,
    Revenue2023: 344582,
    Revenue2022: 398675,
    Revenue2021: 276692,
    Revenue2020: 178574,
    Revenue2019: 259500,
    Revenue2018: 279332,
    NetIncome2023: 36010,
    NetIncome2022: 55740,
    NetIncome2021: 23040,
    NetIncome2020: -22440,
    NetIncome2019: 14340,
    NetIncome2018: 20840,
    description:
      "Es una empresa integrada de petróleo y gas que descubre, explora, desarrolla y produce petróleo crudo, gas natural y líquidos de gas natural. También refina petróleo crudo, produce, transporta, comercializa y vende productos petrolíferos y fabrica aceites lubricantes y lubricantes acabados. ExxonMobil también fabrica y comercializa productos petroquímicos básicos, como olefinas, aromáticos, plásticos de polietileno y polipropileno entre otros.",
  },


  
  // {
  //   ticker: "PBR",
  //   price: 16.54, actual_price:"",
  //   Ratios: ["P/Sales", "EV/EBITDA", "P/FCF"],
  //   Targets: [0.8, 3, 4],
  //   image: "/images/PBR.png",
  //   category: "Commodity",
  //   name: "Petrobras",
  //   Revenue2022: 124474,
  // Revenue2021: 83966,
  // Revenue2020: 53683,
  // NetIncome2022: 36623,
  // NetIncome2021: 19875,
  // NetIncome2020: 1141,
  //   description:
  //     "Es una empresa brasileña de Oil & Gas, con Alta participación estatal. Es el mayor productor de Brasil y de latinoamérica. Actualmente produce 3,69 millones de barriles diarios de petróleo y gas natural y exporta 756 millones de barriles por día. Se destaca por utilizar alta tecnología en operaciones de exploración y producción en aguas abiertas (offshore) contando con el récord de la planta de extracción de crudo más profunda del mundo.",
  // },

];
export default stocks;



